/** @prettier */

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SurfConditions, SurfHeight, TideArrow } from '@surfline/quiver-react';
import classNames from 'classnames';

import spotPropTypes from '../../propTypes/spot';
import { getUserSettings } from '../../selectors/user';
import spotReportPath from '../../utils/urls/spotReportPath';
import { trackEvent } from '../../actions/segmentEvents';
import cameraPropTypes from '../../propTypes/camera';
import { getCamTitle } from '../../utils/getCamTitle';

const getConditionsOverlayClass = isVisible =>
  classNames({
    'sl-cam-overlay__conditions': true,
    'sl-cam-overlay__conditions--visible': isVisible,
  });

const ConditionsOverlay = ({ spot, camAngle }) => {
  const dispatch = useDispatch();
  const { units } = useSelector(getUserSettings);
  const spotLink = `/${spotReportPath(spot._id, spot.name)}`;
  const trackSpotPageLink = () => {
    dispatch(
      trackEvent('Clicked Link', {
        linkUrl: spotLink,
        linkName: 'spot page cam overlay',
        linkLocation: 'multi-cam cam overlay',
        category: 'cams & reports',
      })
    );
    window.location.assign(spotLink);
  };
  return (
    <div className={getConditionsOverlayClass(true)}>
      <div className="sl-cam-overlay__conditions__spot-name">
        <SurfConditions
          conditions={spot?.conditions?.value || 'none'}
          expired={spot.conditions.expired && spot.conditions.human}
        />
        <a href={spotLink} onClick={trackSpotPageLink}>
          {getCamTitle(camAngle.title) || spot.name}
        </a>
      </div>
      <div className="sl-cam-overlay__conditions-containers">
        <span className="sl-cam-overlay__conditions__surf">
          <SurfHeight
            min={spot.waveHeight.min}
            max={spot.waveHeight.max}
            units={units.waveHeight}
            plus={spot.waveHeight.plus}
          />
        </span>
        {spot.tide ? (
          <span className="sl-cam-overlay__conditions__tide">
            {spot.tide.current.height}
            {units.tideHeight}
            <TideArrow direction={spot.tide.next.type === 'LOW' ? 'DOWN' : 'UP'} />
          </span>
        ) : null}
        <span className="sl-cam-overlay__conditions__wind">
          {spot.wind.speed}
          {units.windSpeed}
        </span>
      </div>
    </div>
  );
};

ConditionsOverlay.propTypes = {
  spot: spotPropTypes.isRequired,
  camAngle: cameraPropTypes,
};

ConditionsOverlay.defaultProps = {
  camAngle: {},
};

export default ConditionsOverlay;
